import { action, observable } from 'mobx';
import { SerializedData } from 'bernie-core';
import { AnalyticsStore } from 'bernie-plugin-mobx';
import { Logger, NOOP_LOGGER, SystemEvent, SystemEventLevel } from 'bernie-logger';

import { BaseBexApiStore } from './bex-api-store';
import analyticsWrapper from 'utility/analytics-wrapper';
import { FlightsShoppingPwaFlightServicingConfirmationResults, Sdk } from 'src/__generated__/api';

export class FlightServicingConfirmationStore extends BaseBexApiStore {
  @observable public confirmationHeading: string;

  public hydrate(data: SerializedData): void {
    super.hydrate(data);
  }

  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER, api: Sdk) {
    super(state, logger, api);
  }

  @action
  public setConfirmationHeading(heading: string) {
    this.confirmationHeading = heading;
  }

  public fetchResults(
    variables: FlightsShoppingPwaFlightServicingConfirmationResults.Variables,
    options: HeadersInit,
    analytics: AnalyticsStore
  ): Promise<FlightsShoppingPwaFlightServicingConfirmationResults.FlightsServicingConfirmation> {
    return this.api
      .FlightsShoppingPwaFlightServicingConfirmationResults(variables, options)
      .then(response => {
        const { flightsServicingConfirmation } = response?.data ?? {};

        analyticsWrapper.publishAnalyticsPayload(response, analytics);

        return flightsServicingConfirmation;
      })
      .catch(error => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.CRITICAL, 'SERVICING_CONFIRMATION_FETCH'), error);

        return null;
      });
  }
}

FlightServicingConfirmationStore.DEFAULTS = {
  confirmationHeading: ''
};
